// 1C (oct-2026) — color por servicio: misma paleta que el backend (services_catalog.PALETTE).
export const SERVICE_PALETTE = ['#d4af37', '#2dd4bf', '#3b82f6', '#8b5cf6', '#ec4899', '#ef4444',
  '#f97316', '#84cc16', '#06b6d4', '#6366f1', '#a16207', '#64748b'];

const hexToRgb = (hex) => {
  const h = String(hex || '').replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

/** Texto negro o blanco según la luminancia del fondo (contraste automático). */
export const textOn = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return '#ffffff';
  const [r, g, b] = rgb;
  return (r * 299 + g * 587 + b * 114) / 1000 >= 150 ? '#111111' : '#ffffff';
};

export const withAlpha = (hex, alpha) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return undefined;
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
};

export const isHexColor = (v) => /^#[0-9a-fA-F]{6}$/.test(String(v || ''));

/** Estilos del bloque de cita pintado con el color del servicio; el estado va por borde/opacidad, nunca por fondo. */
export const bookingBlockStyle = (color, status) => {
  if (!isHexColor(color)) return null;
  const faded = status === 'cancelled' || status === 'no_show';
  const fg = textOn(color);
  return {
    backgroundColor: withAlpha(color, faded ? 0.45 : 0.92),
    borderColor: faded ? withAlpha(fg, 0.5) : withAlpha(fg, 0.25),
    borderLeftColor: color,
    borderStyle: status === 'pending' || status === 'cancelled' ? 'dashed' : 'solid',
    color: fg,
    '--block-fg': fg,
    '--block-muted': withAlpha(fg, 0.72),
  };
};
